import { Icon } from '@purpur/library/icon';
import styled from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const SuggestionLink = styled.a`
    color: ${getPurpurColor('textDefault')};
    display: flex;
    align-items: center;
    width: 100%;
    text-decoration: none;

    &:active,
    &:hover,
    &:focus {
        color: ${getPurpurColor('textDefault')};
        text-decoration: none;
    }

    ${purpurFocus()};
`;

export const StyledIcon = styled(Icon)`
    margin-right: ${getPurpurSpacing('100')};
    flex-shrink: 0;
`;

export const DeleteButton = styled.button`
    margin-left: auto;
    height: 1.5rem;
`;
